<template>
  <div style="height: 100%; text-align: left;" v-if="sequence == 1" id="StackedCompanyName">
    <v-tooltip top>
      <template #activator="{ on, attrs }">
        <span
          v-bind="attrs"
          v-on="on"
          class="white--text font-weight-regular"
        >
          {{ companyName }}
        </span>
      </template>
      <span>{{ companyName }}</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: "CompanyStackedColumnTemplate.vue",
  props: {
    companyName: {
      type: String,
      default: null,
    },
    sequence: {
      type: Number,
      default: 0,
    },
  },
};
</script>
